import { ReactNode } from "react"
import { twMerge } from "tailwind-merge"
import { Button } from "./Button"

export const Counter = ({
  children,
  className,
  active,
  disabled,
  onClick,
  noTransition = false,
}: {
  children?: ReactNode
  className?: string
  active?: boolean
  disabled?: boolean
  onClick?: () => void
  noTransition?: boolean
}) => {
  return (
    <Button
      variant={active ? "outline" : "secondary"}
      size="sm"
      onClick={onClick}
      disabled={disabled}
      className={twMerge(noTransition ? "" : "transition-all duration-300")}
    >
      {children}
    </Button>
  )
}
